import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/services/apiClient';
import { trackEvent } from '@/utils/analytics';
import { useAuthStore } from '@/stores/authStore';
import type { CreateProposalRequest } from '@/types/proposal';

interface UseProposalMutationOptions {
  onSuccess: () => void;
}

export function useProposalMutation({ onSuccess }: UseProposalMutationOptions) {
  return useMutation({
    mutationFn: async (data: CreateProposalRequest) => {
      const response = await apiClient.post<{ id: string }, CreateProposalRequest>(
        '/api/v1/proposals',
        data
      );
      return response.data;
    },
    onSuccess: (_data, variables) => {
      const currentUser = useAuthStore.getState().user;
      trackEvent('proposal_submit', {
        website_url: variables.websiteUrl,
        company_name: variables.userCompanyName,
        raksul_id: currentUser?.id,
      });
      onSuccess();
    },
  });
}
